import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import HomePage from "@/HomePage";
import PrivacyPolicy from "@/PrivacyPolicy";
import AdminPanel from "@/AdminPanel";
import JobBoard from "@/JobBoard";
import JobDetail from "@/JobDetail";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/concierge" element={<App />} />
        <Route path="/wallet" element={<Navigate to="/concierge" replace />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/jobs" element={<JobBoard />} />
        <Route path="/jobs/:jobId" element={<JobDetail />} />
        <Route path="/admin/jobs" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
